import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Laverage({ rtl }) {
  const className = rtl
    ? "laverage_section p-100 rtl-style"
    : "laverage_section p-100";
  return (
    <div className={className}>
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>دورة التطوير الفعالة TekRevol</h2>
            <p>
              تتمتع TekRevol بأساس قوي في تطوير تطبيقات الهاتف المحمول باستخدام
              أدوات تكنولوجية متقدمة ومطورين محترفين في المملكة العربية
              السعودية. نقوم بتحسين عمليتنا من خلال نهج يركز على المستخدم،
              لتوفير تجربة جيدة لأولئك الذين يستخدمون تطبيقنا. كما نحافظ أيضًا
              على الشفافية الكاملة طوال مراحل التطوير، ونبقي عملائنا على اطلاع
              بكل خطوة.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
            <div className="process_listing">
              <div className="process_item">
                <div className="number">01</div>
                <h6>توليد الأفكار</h6>
                <p>إجراء اكتشاف المنتج وبحث حول المنتج</p>
              </div>
              <div className="process_item">
                <div className="number">02</div>
                <h6>التصميم</h6>
                <p>
                  إنشاء تصميم تجربة المستخدم، تصميم واجهة المستخدم، والعلامة
                  التجارية
                </p>
              </div>
              <div className="process_item">
                <div className="number">03</div>
                <h6>التطوير</h6>
                <p>برمجة التطبيق بواسطة مهندسينا الخبراء</p>
              </div>
              <div className="process_item">
                <div className="number">04</div>
                <h6>ضمان الجودة</h6>
                <p>اختبار التطبيق والتأكد من أن كل شيء يعمل بشكل جيد</p>
              </div>
              <div className="process_item">
                <div className="number">05</div>
                <h6>الصيانة والدعم</h6>
                <p>
                  إدارة التطبيق معاً بالتعاون مع فريق التكنولوجيا الخاص لدينا
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Laverage;
